export const UPDATE_DATA = 'app/EditSessionPage/Name/UPDATE';
export const UPDATE_VARIABLE = 'app/EditSessionPage/Name/UPDATE_VARIABLE';
